import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    messages: [
        { role: "assistant", content: "Hi how can i help you" },
    ],
    loading: false,
}


const chatSlice = createSlice({
    name: "chat",
    initialState,
    reducers: {
        addMessage: (state, action) => {
            state.messages.push(action.payload);
        },
        setMessages: (state, action) => {
            state.messages = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        updateGreetingByLanguage: (state, action) => {
            const language = action.payload;
            const greeting = language === 'ar' ? 'مرحباً، كيف يمكنني مساعدتك؟' : 'Hi how can I help you?';

            // Update the first message if it's the greeting
            if (state.messages.length === 1 && state.messages[0].role === "assistant") {
                state.messages[0].content = greeting;
            }
        }

    }
});

const chatReducer = chatSlice.reducer;
const chatActions = chatSlice.actions;

export { chatReducer, chatActions };